import service from "../services/analityc.service"; // Asegúrate de que el servicio esté configurado correctamente

export const analitycs = {
    namespaced: true,
    state: {
        cards: [],
    },
    getters: {
        cards: (state) => state.cards,
    },
    actions: {
        async getCards({ commit }) {  // Desestructuramos 'commit' aquí
            try {
                const response = await service.getCards();
                commit('SET_CARDS', response.data);
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async getYear() {  // Desestructuramos 'commit' aquí
            try {
                const response = await service.getYear();
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async getUndelivered() {  // Desestructuramos 'commit' aquí
            try {
                const response = await service.getUndelivered();
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async getUnvalidate() {  // Desestructuramos 'commit' aquí
            try {
                const response = await service.getUnvalidate();
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async getProduction() {  // Desestructuramos 'commit' aquí
            try {
                const response = await service.getProduction();
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async getReportProductionUser(context,data) {  // Desestructuramos 'commit' aquí
            try {
                const response = await service.getReportProductionUser(data);
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        
    },
    mutations: {
        SET_CARDS(state, data) {
            state.cards = data;
        },
    },
};
